import { LocationOutlined } from '@teko/ds-icon';
import { Caption, LegacyInput, Flex, Switch, BottomActionBar, Button, styled, AutoComplete } from '@teko/ds-mobile';
import { Formik } from 'formik';
import React from 'react';
import { t } from '../../i18n.es.js';
import { useAddressForm } from '../../hooks/useAddressForm.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const COUNT_STRING_WITHOUT_STREET_ADDRESS = 4;
const AddressForm = ({
  editingAddress,
  onClose,
  locationService,
  platformCode,
  locationsLimit,
  requireEmail,
  userService,
  allowAddDefaultAdress,
  dataSuggestion,
  openListSuggestion,
  onChangeAddress,
  isLoadingSuggest,
  setOpenListSuggestion,
  customOnProvinceChanged,
  customOnDistrictChanged,
  customOnWardChanged,
  isDisableFullAddressWhenNotOtherInfo,
  getPlaceDetails,
  showAddressNote
}) => {
  const {
    province,
    district,
    ward,
    provinces,
    districts,
    wards,
    onProvinceChanged,
    onDistrictChanged,
    onWardChanged,
    submitForm,
    validateForm,
    isDefault,
    setIsDefault,
    initialFormValues,
    isValidLocation,
    loading,
    message,
    setLocation,
    setPlace
  } = useAddressForm({
    editingAddress,
    locationsLimit,
    locationService,
    userService,
    platformCode,
    requireEmail,
    allowAddDefaultAdress
  });
  const onClickSuggest = async (placeId, setValues, values) => {
    var _a, _b;
    const items = await getPlaceDetails(placeId);
    if (!items || !Array.isArray(items) || !items.length) {
      return;
    }
    const item = items == null ? void 0 : items[0];
    const address = ((_b = (_a = item.fullAddress.split(",")) == null ? void 0 : _a.splice(0, item.fullAddress.split(",").length - COUNT_STRING_WITHOUT_STREET_ADDRESS)) == null ? void 0 : _b.join(",")) || item.fullAddress || "";
    setOpenListSuggestion == null ? void 0 : setOpenListSuggestion(false);
    setPlace({ lat: item.lat, long: item.long });
    const newValue = __spreadValues(__spreadValues({
      provinceCode: item.provinceCode || void 0
    }, item.districtCode ? { districtCode: item.districtCode } : {}), item.wardCode ? { wardCode: item.wardCode } : {});
    setValues(__spreadProps(__spreadValues(__spreadValues({}, values), newValue), {
      address
    }));
    setLocation({
      provinceCode: item.provinceCode,
      districtCode: item.districtCode,
      wardCode: item.wardCode
    });
  };
  const resetPosition = () => {
    setPlace({ lat: void 0, long: void 0 });
  };
  return /* @__PURE__ */ React.createElement(Formik, {
    initialValues: initialFormValues,
    onSubmit: (formValues) => {
      submitForm(formValues).then((res) => onClose ? onClose(res) : null);
    },
    validate: validateForm
  }, ({
    values,
    touched,
    errors,
    isValid,
    handleSubmit,
    handleBlur,
    handleChange,
    setValues
  }) => /* @__PURE__ */ React.createElement("form", {
    onSubmit: handleSubmit
  }, /* @__PURE__ */ React.createElement(StyledAddressForm, null, /* @__PURE__ */ React.createElement(FormFields, null, message.content && /* @__PURE__ */ React.createElement(Caption, {
    color: message.success ? "success500" : "error500"
  }, message.content), /* @__PURE__ */ React.createElement(LegacyInput, {
    label: t("H\u1ECD t\xEAn ng\u01B0\u1EDDi nh\u1EADn"),
    name: "name",
    value: values.name,
    placeholder: t("Nguy\u1EC5n V\u0103n A"),
    error: touched.name && errors.name,
    required: true,
    onChange: handleChange,
    onBlur: handleBlur,
    maxLength: 255
  }), /* @__PURE__ */ React.createElement(LegacyInput, {
    label: t("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i ng\u01B0\u1EDDi nh\u1EADn"),
    value: values.telephone,
    placeholder: "09xxx",
    error: touched.telephone && errors.telephone,
    name: "telephone",
    required: true,
    onChange: handleChange,
    onBlur: handleBlur
  }), /* @__PURE__ */ React.createElement(LegacyInput, {
    label: "Email",
    value: values.email,
    placeholder: t("Nh\u1EADp email c\u1EE7a b\u1EA1n"),
    error: touched.email && errors.email,
    name: "email",
    required: requireEmail,
    onChange: handleChange,
    onBlur: handleBlur
  }), /* @__PURE__ */ React.createElement(StyledAutoComplete, {
    size: "s",
    required: true,
    label: t("T\u1EC9nh/Th\xE0nh ph\u1ED1"),
    searchTitle: t("Ch\u1ECDn T\u1EC9nh/Th\xE0nh ph\u1ED1"),
    placeholder: t("Th\xE0nh ph\u1ED1"),
    searchPlaceholder: t("Ch\u1ECDn T\u1EC9nh/Th\xE0nh ph\u1ED1"),
    value: province ? {
      value: province.code,
      label: province.name,
      data: province
    } : null,
    options: provinces.map((item) => ({
      value: item.code,
      label: item.name,
      data: item
    })),
    onChange: (option) => {
      if (option) {
        onProvinceChanged(option == null ? void 0 : option.data);
        customOnProvinceChanged == null ? void 0 : customOnProvinceChanged(option.data);
        resetPosition();
      }
    }
  }), /* @__PURE__ */ React.createElement(StyledAutoComplete, {
    size: "s",
    required: true,
    label: t("Qu\u1EADn/huy\u1EC7n"),
    searchTitle: t("Ch\u1ECDn Qu\u1EADn/huy\u1EC7n"),
    placeholder: t("Qu\u1EADn/huy\u1EC7n..."),
    searchPlaceholder: t("Ch\u1ECDn Qu\u1EADn/huy\u1EC7n"),
    value: district ? {
      value: district.code,
      label: district.name,
      data: district
    } : void 0,
    options: districts.map((item) => ({
      value: item.code,
      label: item.name,
      data: item
    })),
    onChange: (option) => {
      if (option) {
        onDistrictChanged(option == null ? void 0 : option.data);
        customOnDistrictChanged == null ? void 0 : customOnDistrictChanged(option == null ? void 0 : option.data);
        resetPosition();
      }
    },
    disabled: !province
  }), /* @__PURE__ */ React.createElement(StyledAutoComplete, {
    size: "s",
    required: true,
    label: t("Ph\u01B0\u1EDDng/x\xE3"),
    searchTitle: t("Ch\u1ECDn Ph\u01B0\u1EDDng/x\xE3"),
    placeholder: t("Ph\u01B0\u1EDDng/x\xE3..."),
    searchPlaceholder: t("Ch\u1ECDn Ph\u01B0\u1EDDng/x\xE3"),
    value: ward ? {
      value: ward.code,
      label: ward.name,
      data: ward
    } : void 0,
    options: wards.map((item) => ({
      value: item.code,
      label: item.name,
      data: item
    })),
    onChange: (option) => {
      if (option) {
        onWardChanged(option == null ? void 0 : option.data);
        customOnWardChanged == null ? void 0 : customOnWardChanged(option == null ? void 0 : option.data);
        resetPosition();
      }
    },
    disabled: !district
  }), /* @__PURE__ */ React.createElement(LegacyInput, {
    label: t("\u0110\u1ECBa ch\u1EC9 c\u1EE5 th\u1EC3 (S\u1ED1 nh\xE0, t\xEAn \u0111\u01B0\u1EDDng...)"),
    name: "address",
    value: values.address,
    placeholder: t("S\u1ED1 nh\xE0..."),
    error: touched.address && errors.address,
    required: true,
    onChange: (text) => {
      handleChange(text);
      onChangeAddress == null ? void 0 : onChangeAddress(text.target.value);
      resetPosition();
    },
    onBlur: handleBlur,
    disabled: (!(province == null ? void 0 : province.code) || !(district == null ? void 0 : district.code) || !(ward == null ? void 0 : ward.code)) && isDisableFullAddressWhenNotOtherInfo,
    maxLength: 255
  }), showAddressNote && /* @__PURE__ */ React.createElement(LegacyInput, {
    label: t("Ghi ch\xFA"),
    name: "addressNote",
    value: values.addressNote,
    placeholder: t("V\xED d\u1EE5: C\u1ED5ng m\xE0u xanh, nh\xE0 b\xEAn c\u1EA1nh c\xE2y x\u0103ng"),
    onChange: (text) => {
      handleChange(text);
      resetPosition();
    },
    onBlur: handleBlur,
    maxLength: 500
  }), !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /* @__PURE__ */ React.createElement(SuggestWrapper, null, isLoadingSuggest ? /* @__PURE__ */ React.createElement(Flex, {
    justify: "center",
    align: "center"
  }, /* @__PURE__ */ React.createElement(Spinner, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, {
    style: { textAlign: "left" }
  }, t("G\u1EE3i \xFD")), dataSuggestion.map((item) => {
    return /* @__PURE__ */ React.createElement(ItemSuggestion, {
      key: item.fullAddress,
      onClick: () => onClickSuggest == null ? void 0 : onClickSuggest(item.placeId, setValues, values)
    }, /* @__PURE__ */ React.createElement(LocationOutlined, null), /* @__PURE__ */ React.createElement(Text, {
      style: { textAlign: "left", marginLeft: 8 }
    }, item.fullAddress));
  }))), !(editingAddress == null ? void 0 : editingAddress.isDefault) && !allowAddDefaultAdress && /* @__PURE__ */ React.createElement(SwitchWrapper, null, /* @__PURE__ */ React.createElement("label", null, t("\u0110\u1EB7t l\xE0m m\u1EB7c \u0111\u1ECBnh")), /* @__PURE__ */ React.createElement(Switch, {
    checked: isDefault,
    onChange: (value) => setIsDefault(value)
  }))), /* @__PURE__ */ React.createElement(BottomActionBar, {
    zIndex: 1030
  }, /* @__PURE__ */ React.createElement(Button, {
    block: true,
    type: "submit",
    onMouseDown: (event) => {
      event.preventDefault();
    },
    variant: "primary",
    disabled: !isValid || !isValidLocation() || loading || requireEmail && !values.email
  }, t("Ho\xE0n t\u1EA5t"))))));
};
const StyledAddressForm = styled.div((props) => `
  padding-bottom: env(safe-area-inset-bottom);
  background-color: ${props.theme.colors.white};
`);
const FormFields = styled.div`
  padding: 0.75rem 1rem;
  overflow: scroll;
  padding-bottom: 3.75rem;
`;
const SwitchWrapper = styled.div`
  label {
    font-weight: 500;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;
const StyledAutoComplete = styled(AutoComplete)`
  margin-bottom: 1.5rem !important;
`;
const SuggestWrapper = styled.div`
  background-color: #fafafa;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: scroll;
`;
const ItemSuggestion = styled.div`
  padding: 8px 10px;
  cursor: pointer;
`;
const Text = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #434657;
`;
const Spinner = styled.div(() => `
  border: 3px solid #BBDEFB;
  border-top-color: #2196F3;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin: 0 0.5rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`);

export { AddressForm, ItemSuggestion, Spinner, SuggestWrapper };
